define('app/errorLogging',[],function () {
    window.onerror = function () {
        return window.isLive;
    };
});
